export default "/_next/static/videos/09-01-001-LandingEnglish_optimized.mp4";